export default "__VITE_ASSET__DH5DVx4V__"